export const PreCodedStatusEnum = {
    0: { value: 'Unassigned', UI: 'Unassigned' },
    1: { value: 'Assigned', UI: 'Assigned' },
};

export default { PreCodedStatusEnum };
